import React, { useState, useEffect, useMemo } from 'react';
import PackagesMenuIcon from 'assests/icons/packages-menu.icon';
import PackagesMenuActiveIcon from 'assests/icons/packages-menu-active.icon';
import MessagesMenuIcon from 'assests/icons/messages-menu.icon';
import MessagesMenuActiveIcon from 'assests/icons/messages-menu-active.icon';
import ReportsMenuIcon from 'assests/icons/reports-menu.icon';
import ReportsMenuActiveIcon from 'assests/icons/reports-menu-active.icon';
import { useDimensions } from 'context/dimensions.context';
import Typography from '../typography/typography';
import { Row, Col, Menu, Dropdown, message } from 'antd';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import logo from 'assests/images/logo.png';
import logoWhite from 'assests/images/logo-white.png';
import './menu.less';
import DownChevronIcon from 'assests/icons/down-chevron.icon';
import RightChevronIcon from 'assests/icons/right-chevron.icon';
import HamburgerMenuIcon from 'assests/icons/hamburger-menu.icon';
import CloseIcon from 'assests/icons/close.icon';
import { useLocation } from 'react-router-dom';
import { Button } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from 'actions/auth.action.js';
import {logoutUnAuth} from 'services/login.service';
import { customMessages } from 'utils';
import {getRemainingCredit }  from 'services/profile.service';

const { Text } = Typography;

const PackagesIcon = ({ active, ...rest }) =>
  active ? (
    <PackagesMenuActiveIcon {...rest} />
  ) : (
    <PackagesMenuIcon {...rest} />
  );

const MessagesIcon = ({ active, ...rest }) =>
  active ? (
    <MessagesMenuActiveIcon {...rest} />
  ) : (
    <MessagesMenuIcon {...rest} />
  );

const ReportsIcon = ({ active, ...rest }) =>
  active ? <ReportsMenuActiveIcon {...rest} /> : <ReportsMenuIcon {...rest} />;

const menuData = [
  { pathname: '/ReportsPage', name: 'Raporlar', Icon: ReportsIcon },
  { pathname: '/Messages', name: 'Mesajlar', Icon: MessagesIcon },
  { pathname: '/Packages', name: 'Paketler', Icon: PackagesIcon },
];

// add routes for onClick
const hamburgerMenu = [
  {
    name: 'Raporlar',
    Icon: ReportsIcon,
    link: '/ReportsPage',
  },
  {
    name: 'Mesajlar',
    link: '/Messages',
    Icon: MessagesIcon,
    subMenu: [
      {
        name: 'Mesaj Gönder',
        link: '/Messages',
      },
      {
        name: 'Rehberim',
        link: '/Guide',
      },
      {
        name: 'Kara Liste',
        link: '/BlackList',
      },
    ],
  },
  {
    name: 'Paketler',
    link: '/Packages',
    Icon: PackagesIcon,
  },
  {
    name: 'Profil',
    link: '/Profile',
    Icon: PackagesIcon,
    subMenu: [
      {
        name: 'Profil Bilgileri',
        link: '/Profile',
      },
      {
        name: 'Yetki İşlemleri',
        link: '/Permission',
      },
      {
        name: 'Ünvan İşlemleri',
        link: '/Title',
      },
      {
        name: 'Yardım',
        link: '/CreditPurchaseHelp',
      },
    ],
  },
];

const MenuItem = ({ name, Icon, pathname }) => {
  return (
    <NavLink
      to={pathname}
      className="menu-item-button"
      activeClassName="active-button"
    >
      <Icon active={true} className={`menu-item-logo active`} />
      <Icon active={false} className={`menu-item-logo passive`} />
      {name}
    </NavLink>
  );
};

const HamburgerMenuItem = ({ name, link, isSub, rest }) => {
  return (
    <>
      <NavLink
        to={link}
        className={`hamburger-menu-link ${
          isSub ? 'hamburger-menu-sub-link' : ''
        }`}
        {...rest}
      >
        <span>{name}</span>
        <RightChevronIcon />
      </NavLink>
    </>
  );
};

const SubHamburgerItem = (props) => (
  <HamburgerMenuItem
    isSub
    className="hamburger-menu-link hamburger-sub-menu-link"
    {...props}
  />
);

const Header = ({
  customMenuRender: Component,
  withoutDropdown,
  hamburgerMenuData,
  hamburgerMenuClass,
  hamburgerMenuWithButton,
  withoutCreditInfo,
  menuSinglePageV2,
  whiteLogo,
  setIsHidden,
  isHidden,
}) => {
  let location = useLocation();
  const { isScreenLG } = useDimensions();
  const [isHamburgerMenuOpened, setIsHamburgerMenuOpened] = useState(false);
  const [accountInfo, setAccountInfo] = useState({});
  const {dispatch} = useDispatch();
  const {user} = useSelector(state => state.auth);
  const {isAuth} = useSelector(state => state.auth);
  const onClickHamburgerIcon = () => {
    setIsHamburgerMenuOpened(!isHamburgerMenuOpened);
    setIsHidden(!isHidden)
  }

  function getAvailableCredit() {
    getRemainingCredit()
      .then((result) => {
        setAccountInfo(result);        
      }).catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
  }

  useEffect(() => 
  {
    if (!hamburgerMenuWithButton)
    {
      getAvailableCredit();
    }
  }, [hamburgerMenuWithButton]);

  useEffect(() => {
    setIsHamburgerMenuOpened(false);
  }, [isScreenLG]);
  const activeMenu = useMemo(() => {
    return menuData.find(
      (_) => location && location.pathname.includes(_.pathname)
    );
  }, [location]);

  const userDropdownMenu = (
    <Menu className="menu__user-dropdown">
      <Menu.Item>
        <NavLink to="/Profile">Profil Bilgileri</NavLink>
      </Menu.Item>
      {(user?.masterOtp) &&
      <Menu.Item>
        <NavLink to="/Permission">Yetki İşlemleri</NavLink>
      </Menu.Item>
      }
      <Menu.Item>
        <NavLink to="/Title">Ünvan İşlemleri</NavLink>
      </Menu.Item>
      <Menu.Item>
        <NavLink to="/CreditPurchaseHelp">Yardım</NavLink>
      </Menu.Item>
      <Menu.Item>
      <NavLink to ="/Login" onClick={logoutUnAuth()}>
        <button>Çıkış</button>
        </NavLink>
      </Menu.Item>
    </Menu>
  );

  return !isScreenLG ? (
    <Row
      className={classNames(
        'menu',
        { 'menu--v2': Component },
        { 'menu--single-page': withoutDropdown },
        { 'menu--single-page--v2': menuSinglePageV2 }
      )}
    >
      <div className="container">
        <Col className="menu-logo-container">
          {menuSinglePageV2 || whiteLogo ? <NavLink to="/"><img className="menu-logo" src={logoWhite} /></NavLink> : <NavLink to="/Messages"><img className="menu-logo" src={logo} /></NavLink> }
          { Component ? <NavLink to="/Messages"><button className="back-to-homepage"><DownChevronIcon /> <span>Ana Sayfaya Dön</span> </button></NavLink> : false }
        </Col>
        <Col span={12}>
          <Row className="menu-item-container">
            {Component ? (
              <Component />
            ) : (
              <>
                {menuData.map((item, index) => (
                  <Col key={item.name} span={8}>
                    <MenuItem {...item} active={item === activeMenu} key={item.name} />
                  </Col>
                ))}
              </>
            )}
          </Row>
        </Col>
        {!withoutDropdown && (
          <Col>
            <Dropdown
              className="menu-dropdown"
              overlay={userDropdownMenu}
              trigger={['click']}
              placement="bottomCenter"
            >
              <Row className="menu-credit">
                <Col className="menu-credit-body" span={18}>
                  <Text className="menu-credit-title" ellipsis>
                    {accountInfo?.msisdn}
                  </Text>
                  <Text className="menu-credit-value">
                    <strong>{accountInfo?.availableCredit? accountInfo?.availableCredit.toLocaleString('tr-TR') + " Kredi" :""}</strong>
                  </Text>
                </Col>
                <Col className="menu-credit-icon" span={6}>
                  <DownChevronIcon />
                </Col>
              </Row>
            </Dropdown>
            <span className="menu__validity">Geçerlilik: {accountInfo?.endDate}</span>
          </Col>
        )}
      </div>
    </Row>
  ) : (
    <div
      className={classNames(
        'container hamburger-menu-container',
        hamburgerMenuClass,
        {'mobile-menu-opened': isHamburgerMenuOpened},
        {'menu--single-page--v2': menuSinglePageV2 }
      )}
    >
      <div className="hamburger-menu">
        <Col span={24} className="hamburger-menu-header-container">
          <Row className="hamburger-menu-header">
            <Col className="hamburger-menu-logo-container">
              { menuSinglePageV2 && isHamburgerMenuOpened ?
                <img className="hamburger-menu-logo" src={logoWhite} />
              : whiteLogo && isHamburgerMenuOpened ?
                <img className="hamburger-menu-logo" src={logo} />
              : menuSinglePageV2 || whiteLogo ?
                <img className="hamburger-menu-logo" src={logoWhite} />
              :
                <img className="hamburger-menu-logo" src={logo} />
              }
            </Col>
            <Col className="hamburger-menu-icon" onClick={onClickHamburgerIcon}>
              {isHamburgerMenuOpened ? <CloseIcon /> : <HamburgerMenuIcon />}
            </Col>
          </Row>
        </Col>
        {Component ? (
          <Col span={24}>
            <Row className="menu-item-container">
              <Component />
            </Row>
          </Col>
        ) : null}
        {isHamburgerMenuOpened && (
          <Col span={24} className="hamburger-menu-body">
            <Row>
              {!withoutCreditInfo && (
                <Col span={24} className="hamburger-menu-credit-container">
                  <Row className="hamburger-menu-credit ">
                    <span>  {accountInfo?.msisdn}</span>
                    <div className="hamburger-menu-credit-description">
                      <span>
                        <strong>{accountInfo?.availableCredit}</strong>Kredi
                      </span>
                      <span>Geçerlilik: {accountInfo?.endDate}</span>
                    </div>
                  </Row>
                </Col>
              )}
            </Row>
            {hamburgerMenuData.map((item) =>
              item.subMenu ? (
                <>
                  <HamburgerMenuItem {...item} />
                  {item.subMenu.map((subItem) => (
                    <>
                      <SubHamburgerItem key={subItem.name} {...subItem} />
                    </>
                  ))}
                </>
              ) : (
                <HamburgerMenuItem key={item.name} {...item} />
              )
            )}
            {hamburgerMenuWithButton && (
               <NavLink to="/Login">
              <Button shape="round" type="ghost">
                Üye Girişi / Kayıt Ol
              </Button>
              </NavLink>
            )}
          </Col>
        )}
      </div>
    </div>
  );
};
export default Header;

Header.defaultProps = {
  hamburgerMenuData: hamburgerMenu,
};
